import { Ticket } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import { Field, Formik } from "formik";
import { Button, Card, Form, Icon, List } from "semantic-ui-react";
import React from "react";

type TicketRecipientsProps = {
  ticket: Ticket;
  updateEmails: Function;
};

const TicketRecipients = ({ updateEmails, ticket }: TicketRecipientsProps) => {
  const removeEmail = (s: string) => {
    const newEmails = ticket.emailRecipients
      .filter((email) => email !== s)
      .join(",");
    updateEmails(newEmails);
  };

  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>Email Recipients</Card.Header>
        <List verticalAlign="middle">
          {ticket.emailRecipients.map((s) => (
            <List.Item key={s}>
              <List.Content floated="right">
                <Button
                  color="red"
                  icon
                  size="mini"
                  onClick={() => removeEmail(s)}
                >
                  <Icon name="delete" />
                </Button>
              </List.Content>
              <List.Icon name="mail" />
              <List.Content>
                <a href={`mailto:${s}`}>{s}</a>
              </List.Content>
            </List.Item>
          ))}
        </List>
        <Formik
          initialValues={{ email: "" }}
          onSubmit={(values, actions) => {
            if (values.email.length > 0) {
              const emailRecipients = [
                ...ticket.emailRecipients,
                values.email,
              ].join(",");
              updateEmails(emailRecipients);
              actions.setFieldValue("email", "");
            }
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Field
                name="email"
                label="Email"
                type="email"
                placeholder="Enter Email address"
                component={CallableInput}
              />
              <Button primary type="submit" size="mini">
                Add Email
              </Button>
            </Form>
          )}
        </Formik>
      </Card.Content>
    </Card>
  );
};

export default TicketRecipients;
